// extracted by mini-css-extract-plugin
export default {"special_title2":"SpecialTitle2_special_title2__hr3-l","special_title2_text":"SpecialTitle2_special_title2_text__P8d7K"};